import clsx from "clsx";
import get from "lodash/get";
import React, { useEffect, useRef } from "react";
import { useForm } from "react-hook-form/dist/index.ie11";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import Pagination from "~/components/Pagination";
import Search from "~/components/Search";
import Table from "~/components/Table";
import Button from "~/shared/ui/Fields/Button";
import DatePicker from "~/shared/ui/Fields/DatePicker";
import Select from "~/shared/ui/Fields/Select";
import { NOTIFICATIONS } from "~/constans/notifications";
import { STATUS_TYPES } from "~/constans/statuses";
import { useDealersForSelect } from "~/entity/Dealers/hooks/useDealersForSelect";
import { useGetLocationData, useSetLocationData } from "~/hooks/locationData";
import { getFormatDate } from "~/libs/getFormatDate";
import { ZD_OPTIONS_USOYO } from "~/pages/ZD/MainZD/options";
import {
  ReportType,
  useAddNotificationMutation,
  useGetAllZdUsuoQuery,
  useGetReportAllZdLazyQuery,
} from "~/schemas/generated/graphql";
import { usePermissions } from "~/shared/context/PermissionContext";
import { addGMTOffsetToDate } from "~/shared/lib/addGMTOffsetToDate";

import s from "~/pages/Dealers/Dealers.less";

const MainZD = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { hasPermission } = usePermissions();

  const goPlanReport = () => {
    history.replace("/zd/plan_report/");
  };
  const setData = useSetLocationData();
  const {
    selectedDate,
    currentId,
    page,
    count,
    searchText,
    searchTextForSelect,
    dateBegin,
  } = useGetLocationData();
  const language = localStorage.getItem("language");
  const [addNotificationMutation] = useAddNotificationMutation({});
  const isEn = language === "en";
  const currentDate = selectedDate ? new Date(selectedDate) : new Date();

  const watchDefaultActualDate = useForm({ defaultValues: { date: null } });

  const chosenDate = watchDefaultActualDate.watch("date");
  const lastSetDateRef = useRef(null);

  useEffect(() => {
    const newDateValue = chosenDate ? addGMTOffsetToDate(chosenDate) : null;
    const newDateTimestamp =
      newDateValue instanceof Date
        ? newDateValue.getTime()
        : newDateValue === ""
        ? null
        : newDateValue;

    if (newDateTimestamp !== lastSetDateRef.current) {
      lastSetDateRef.current = newDateTimestamp;
      setData("dateBegin", newDateValue === "" ? null : newDateValue);
    }
  }, [chosenDate]);

  const { control, reset, watch, setValue } = useForm();

  const watchDealer = watch("nameDealer");

  const {
    options: dealershipsForSelect,
    loading: dealersLoading,
    onScrollBottom: onScrollBottomDealers,
    searchDealers: searсhDealer,
  } = useDealersForSelect();

  const [getReportAllZDLazyQuery, ReportAllZDLazyQuery] =
    useGetReportAllZdLazyQuery({
      onCompleted(data) {
        const hash = get(data, `ZdReportsGetter.ZdStatus.fileHash`);
        hash &&
          addNotificationMutation({
            variables: {
              status: STATUS_TYPES.FORMATION,
              type: NOTIFICATIONS.report,
              id: hash,
            },
          });
      },
      fetchPolicy: "no-cache",
    });

  const getReports = () => {
    getReportAllZDLazyQuery({
      variables: {
        Type: ReportType.Excel,
      },
    });
  };

  const allZdGet = useGetAllZdUsuoQuery({
    variables: {
      page,
      count,
      name: (watchDealer?.value && watchDealer?.label) || searchText,
    },
    fetchPolicy: "no-cache",
  });

  const allZd = get(
    allZdGet,
    "data.ZdCommonGetter.getZdGlobalInfoForDealers.items",
    []
  ).map(({ Dealer, DealerId, lastChange, lastCheckedChange, status }) => ({
    INN: Dealer.INN,
    DealerName: isEn ? Dealer.DealerNameEn : Dealer.DealerName,
    City: Dealer.city,
    code: Dealer.code,
    ZdUpdatedAt: getFormatDate(lastChange),
    StatusUpdatedAt: getFormatDate(lastCheckedChange),
    status: t(`zd.${status}`),
    DealerId,
  }));

  const total = get(
    allZdGet,
    "data.ZdCommonGetter.getZdGlobalInfoForDealers.total",
    ""
  );

  return (
    <>
      <div className={s.wrapper}>
        <div className={s.s_dealer_title}>
          {t("zd.zd_title")}
          <div>
            {hasPermission("zd.planReports.get") && (
              <Button
                txtBtn={t("zd.plan_report")}
                onClick={goPlanReport}
                orange
                small
              />
            )}
          </div>
        </div>

        <div className={s.form_historical_date}>
          <span className={s.text}>{t("cep.actual_date_on")}</span>
          <DatePicker
            name={"date"}
            control={watchDefaultActualDate.control}
            gray
            maxDate={new Date()}
            customClassName={s.date_picker}
            dateFormat={"dd.MM.yyyy"}
          />
        </div>

        {hasPermission("zd.reports.get") && (
          <div className={s.search}>
            <Search />
            <Button
              txtBtn={t("zd.button")}
              small
              green
              customClassName={clsx(s.correct_margin)}
              onClick={getReports}
              loading={ReportAllZDLazyQuery.loading}
            />
          </div>
        )}

        <Pagination total={total}>
          <Table
            options={ZD_OPTIONS_USOYO}
            items={allZd}
            loading={allZdGet.loading}
            sortable={false}
            refetch={allZdGet.refetch}
            type={"usouo"}
          />
        </Pagination>
      </div>
      <div className={'offset-footer'} />
    </>
  );
};
export default MainZD;
